import { Box } from "@mui/material";
import { useContext, useState } from "react";
import { EmploymentsHierarchy } from "../../../talents/talentAPI";
import { AccessRightContext } from "../../../user/AccessRightProvider";
import Bundle from "../Shared/Bundle";
import BundleHeader from "../Shared/BundleHeader/BundleHeader";
import { EmploymentRowType } from "../types";

interface Props {
  sectionName: string;
  employmentsHierarchy: EmploymentsHierarchy[];
  translatedTESNames: { [key: string]: string };
  bundleOpen?: boolean;
  type: EmploymentRowType;
  onRangeUpdated?: () => void;
}

const BundleSection = ({
  sectionName,
  employmentsHierarchy,
  translatedTESNames,
  bundleOpen,
  type,
  onRangeUpdated,
}: Props) => {
  const [open, setOpen] = useState<boolean>(bundleOpen || false);

  const { canReadEmployment } = useContext(AccessRightContext);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        background: "#FFFFFF",
        alignItem: "center",
      }}
    >
      <BundleHeader open={open} setOpen={setOpen} title={sectionName} />
      {open &&
        employmentsHierarchy.length > 0 &&
        employmentsHierarchy.map((employmentBundle, bundleIndex, array) => (
          <Bundle
            disabled={!canReadEmployment(employmentBundle.employerId)}
            key={`openBundle-${bundleIndex}`}
            employmentBundle={employmentBundle}
            continuousEmploymentId={employmentBundle.continuousEmploymentId}
            translatedTESNames={translatedTESNames}
            inner={true}
            bundleOpen={bundleOpen}
            bundleIndex={bundleIndex}
            type={type}
            isShift={employmentBundle.isShift}
            isLastChild={bundleIndex === array.length - 1}
            onRangeUpdated={onRangeUpdated}
          />
        ))}
    </Box>
  );
};

export default BundleSection;
